export enum RoleType {
  SECRETARY= 'SECRETARY',
  AGENT= 'AGENT',
  AGENCY_ADMIN= 'AGENCY_ADMIN',
  OWNER= 'OWNER',
  ADMIN= 'ADMIN'
}
